module.exports = function getResource(label, vars = []) {
    let resources = {
        love: ' j’aime',
        loves: ' coups de cœur'
    };

    return resources[label];
};
